import { Box, Typography, useTheme } from "@mui/material";

const DomainTab = ({ array, headLabel }: {
    array:{name:string}[]
    headLabel?: string
}) => {
  const theme = useTheme();

  const toSlug = (value: string) =>
    value.toString().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") || "item";

  return (
    <Box
      id="domain-tab-container"
      data-testid="domain-tab-container"
      role="list"
      sx={ {
        display: "flex",
        flexWrap: "wrap",
        gap: "0.5rem",
        marginTop: "2rem"
      } }
    >
      { headLabel && (
        <Box
          id={ `domain-tab-head-${toSlug(headLabel)}` }
          data-testid="domain-tab-head"
          role="listitem"
          aria-label={ headLabel }
          sx={ {
            alignItems: "center",
            backgroundColor: theme.customColors.backgroundSecondaryAlternative,
            border: `1px solid ${theme.customColors.backgroundAccent}`,
            borderRadius: "4px",
            display: "flex",
            height: "1.5rem",
            justifyContent: "center"
          } }
        >
          <Typography
            sx={ { padding:"0.125rem 0.5rem" } }
            fontSize={ "0.75rem" }
            fontWeight={ 600 }
            color={ theme.customColors.textTag }
          >
            { headLabel }
          </Typography>
        </Box>
      ) }
      { array.map((el:{name:string},i:number) => {
        const slug = toSlug(el.name);
        return (
          <Box
            key={ `${el.name}-${i}` }
            id={ `domain-tab-item-${slug}` }
            data-testid="domain-tab-item"
            role="listitem"
            aria-label={ el.name }
            sx={ {
              alignItems: "center",
              backgroundColor: `rgba(${theme.customColors.backgroundSecondaryHover})`,
              borderRadius: "4px",
              display: "flex",
              height: "1.5rem",
              justifyContent: "center"
            } }
          >
            <Typography
              sx={ { padding:"0.125rem 0.5rem" } }
              fontSize={ "0.75rem" }
              fontWeight={ 600 }
              color={ theme.customColors.textPrimary }
            >
              { el.name }
            </Typography>
          </Box>
        );
      }) }

    </Box>
  );
};
export default DomainTab;
